if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;
			const is_slot_bar = this.getAttribute("data-resultbar-input") || null;
			if ( parseInt(qty.value) - 1 < qtyMin && !is_slot_bar == "true") {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			// jk cust
				let products = JSON.parse(localStorage.getItem("bundleProducts") || "[]"); 
				const urlParams = window.location.search;  
				if (!(urlParams.includes("?page="))) {
					localStorage.removeItem('bundleProducts');
				}else{
					const cardId = qty.getAttribute("data-var-id");
					const product = products.find(p => p.id === cardId);
					if (product) {
						const quantity = product.quantity;
						qty.value = quantity;
						const is_remove = false;
						 if (typeof bundleQty == "function") bundleQty(qty,is_remove);
						if (typeof addProductInSlot == "function") addProductInSlot(qty,true);
					}
				}
			// end

			qty.addEventListener('change', (e)=>{
				const currentQty = parseInt(qty.value);
				if ( parseInt(qty.value) - 1 < qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}
				if ( parseInt(qty.value) + 1 > qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}
				// jk cust
				const is_remove = false;
				 if (typeof bundleQty == "function") bundleQty(qty,is_remove);				
				if (typeof addProductInSlot == "function") addProductInSlot(qty,true);
				if (typeof update_addons == "function") update_addons(qty,qty.value);
				// end
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty - 1 >= qtyMin ) {
						qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - 1 <= qtyMin ) {
						qtyMinus.classList.add('disabled');
					}
					console.log("qty.value",currentQty - 1 >= qtyMin);
				}
				// jk cust
				const is_remove = false;
				if (typeof minBundleQty == "function") minBundleQty(qty,is_remove);
				if (typeof update_addons == "function") update_addons(qty,qty.value);				
				// end
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + 1 <= qtyMax ) {

						const parent = qty?.closest(".collection-grid-cust") ;
						const is_bundle_box = parent?.querySelector(".individual_spice_box");
						console.log("is_bundle_box",is_bundle_box)
						if(is_bundle_box){
							if(qty.value == 1 && qty.hasAttribute("is-first-time")){								
								qty.value = 1;
								qty.removeAttribute("is-first-time");							
							}else{
								qty.value = currentQty + 1;
								qtyMinus.classList.remove('disabled');
							}
						}else{							
							qty.value = currentQty + 1;
							qtyMinus.classList.remove('disabled');
						}
					} 
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
				}
				// jk cust
				const is_remove = false;
				console.log("bundleQty", typeof bundleQty === 'function')
				if(typeof bundleQty === 'function'){
					 if (typeof bundleQty == "function") bundleQty(qty,is_remove);
					 if (typeof addProductInSlot == "function") addProductInSlot(qty,true);
				}
				if (typeof update_addons == "function") update_addons(qty,qty.value);
				// end
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}